var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDescription(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.34326 15.5877H11.6692V14.1887H4.34326V15.5877ZM4.34326 11.628H11.6692V10.229H4.34326V11.628ZM2.38656 19.2973C1.91388 19.2973 1.51157 19.1313 1.17964 18.7994C0.847721 18.4674 0.681763 18.0652 0.681763 17.5926V2.4058C0.681763 1.93325 0.847721 1.53101 1.17964 1.19907C1.51157 0.867139 1.91451 0.701172 2.38846 0.701172H10.25L15.3182 5.7569V17.5905C15.3182 18.0645 15.1523 18.4674 14.8203 18.7994C14.4884 19.1313 14.0861 19.2973 13.6134 19.2973H2.38656ZM9.56059 6.4588V2.10017H2.38846C2.31155 2.10017 2.24103 2.13223 2.17691 2.19635C2.11281 2.26045 2.08076 2.33096 2.08076 2.4079V17.5905C2.08076 17.6675 2.11281 17.738 2.17691 17.8021C2.24103 17.8662 2.31155 17.8983 2.38846 17.8983H13.6115C13.6884 17.8983 13.7589 17.8662 13.8231 17.8021C13.8872 17.738 13.9192 17.6675 13.9192 17.5905V6.4588H9.56059Z",
    fill: "#038E83"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescription);
export default __webpack_public_path__ + "static/media/description.874c804b.svg";
export { ForwardRef as ReactComponent };